<template>
    <div>
        <input v-on:keyup.enter="testApp" v-model="game_id" placeholder="Nhập ID App">
        <!-- <input v-on:keyup.enter="testApp" v-model="current_language" placeholder="Nhập Ngôn Ngữ"> -->
        <select v-model="current_language">
            <option disabled value="">Chọn Ngôn ngữ</option>
            <option v-on:keyup.enter="testApp" v-for="(lang, index) in $store.state.lang" :key="index">{{ lang }}</option>
        </select>
        <button v-on:click="testApp">Click hoặc Enter</button>
        <div v-if="game.quiz && game.quiz.name"><span>title: {{ game.quiz.name }}</span></div>
        <div v-if="game.quiz && game.quiz.title">title2: {{ game.quiz.title }}</div>
        <div v-if="game.quiz && game.quiz.desc">desc: {{ game.quiz.desc }}</div>
        <div class="grid-container" v-if="resultData.length">
            <div class="grid-item" v-for="(img, index) in resultData" :key="index">
                <img :src="img" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import GameItem from './GameItem';
import Drawing from './drawing';
import Scratch from './Scratch';
import axios from 'axios';
import { VueTyper } from 'vue-typer';
import WebFont from 'webfontloader';
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import ImageFilters from '@/lang/imagefilters'
// console.log(faceapi)

export default {
    name: "Game",
    data: function() {
        return {
            title: "",
            resultData: [],
            game: {},
            result: {},
            game_id: "11793",
            current_language: "vi",
            font_path: "./static/fonts/",
            texts_loaded: [],
            canvas_virtual: null,
            canvas_context: null,
            canvas_data: null,
            canvas_image: null,
            canvas_ready: false,
            current_step: "initial",
            loadingFbShare: false,
            loadingFbShareHideEffect: false,
            images: {},
            input: '',
            step: 1,
            active_animation: false,
            SelectIndex: [],
            countNumber: 0,
            interaction: [],
            imageMultipleSelected:[],
            countStep: 1,
            sumStep: 0,
            canclick: false,
            Minput: [],
            mutilData: {},
            temp: "",
            showtextNumber: true,
            general: null,
            base64Draw: null,
            selectText: '',
            features: {},
            imgTime: 0,
            scratch: {
                text: ""
            },
            size: {
                width: 300,
                height: 300
            },
            fullResult: []
        }
    },
    components: {
        'vue-typer': VueTyper,
        GameItem: GameItem,
        Drawing: Drawing,
        Scratch: Scratch
    },
    computed: {
        ...mapGetters(["listGames", "listHomes", "getUserInfo", "getInapp", "getHistory", "getEntry", "getApiGender", "getContents", "getGender", "getFastAds"]),
    },
    mounted: function() {
    },
    updated: function() {
    },
    watch: {
    },
    methods: {
        ...mapActions(["fetch_top_games", "removeById", "removeGamePageById", "set_history", "fetch_data_game", "set_gender"]),
        testApp: function(){
            console.log(this.game_id)
            console.log(this.current_language)
            if(!this.game_id || !this.current_language) alert("id app và ngôn ngữ không được trống!!")
            else{
                this.getGame();
            }
        },
        resetGame: function(){
            try{
                var t = this
                this.title = ""
                this.resultData = []
                this.canvas_ready = false
                this.canvas_data = null
                this.current_step = "initial"
                this.texts_loaded = []
                this.input = '';
                this.images = {}
                this.result = {}
                this.game = {}
                this.mutilData = {}
                this.step = 1
                this.imageMultipleSelected = []
                this.countStep = 1
                this.sumStep = 0
                this.SelectIndex = []
                this.countNumber = 0
                this.interaction = []
                this.canclick = true
                this.temp = ""
                this.showtextNumber = true
                this.general = null
                this.selectText = ""
                this.fullResult = []
            }catch(err){
                window.gtag("event", "resetGame Err", {
                    event_category: "resetGame Err",
                    event_label: err,
                    value: 1
                })
            }
        },
        getGame: function(e) {
            var t = this 
            t.resetGame()
            var data = {
                language: this.current_language,
                id: this.game_id
            }
            this.fetch_data_game(data)
            .then(function(e){
                t.beforeLoadJson(t.getContents)
            })
            .catch(function(e){
                console.log(e)
            })
        },
        beforeLoadJson: function(res){
            console.log(res)
            this.game = res
            try{
                var t = this;
                switch(t.getContents.quiz.type){
                    case "choose_mutil":
                        t.interaction = res.question;
                        t.result = res.result;
                        t.sumStep = res.question.length;
                        if (t.getContents.quiz.unisex && t.getContents.quiz.unisex === "0") {
                            t.$set(t.mutilData, 'gender', 'female')
                            _.forEach(t.interaction, function(e){
                                if (e.type == "image") {
                                    t.$set(t.mutilData, e.var, {})
                                }
                                if (e.type == "mutilImage") {
                                    if (e.hasOwnProperty("isRandom") && e.isRandom) {
                                        e.options = _.shuffle(e.options)
                                    }
                                }
                                if (e.type == "scratch") {
                                    let ran = e.options[Math.floor(Math.random() * e.options.length)]
                                    t.$set(t.scratch, "text", ran)
                                }
                            })
                            t.current_step = "select_mutil";
                        }else if (t.getContents.quiz.random && t.getContents.quiz.random === "1") {
                            t.beforeMutilApp()
                        }else{
                            _.forEach(t.interaction, function(e){
                                if (e.type == "gender" || e.type == "image") {
                                    t.mutilData[e.var] = {}
                                }
                                if (e.type == "mutilImage") {
                                    if (e.hasOwnProperty("isRandom") && e.isRandom) {
                                        e.options = _.shuffle(e.options)
                                    }
                                }
                                if (e.type == "scratch") {
                                    let ran = e.options[Math.floor(Math.random() * e.options.length)]
                                    t.$set(t.scratch, "text", ran)
                                }
                            })
                            t.current_step = "select_mutil";
                        }
                        break;
                    default:
                }
                t.title = t.getContents.quiz.name
            }catch(err){
                console.log(err)
            }
        },
        beforeMutilApp: async function(){
            try{
                var t = this
                window.scrollTo(0, 0);
                var rd = Math.floor(Math.random() * t.result.length);
                t.result = t.result[rd];
                var res = {...t.result}
                _.forEach(t.result.overlays, function(e, index){
                    if (e.data) {
                        if (e.data.operation.operator == "random") {
                            if (e.type == "background") {
                                var items = []
                                _.forEach(e.data.dataset, (p, idx)=>{
                                    let item = {...res.overlays[index]}
                                    item.src = p
                                    item.ty = "random"
                                    items.push(item)
                                })
                                t.fullResult.push(items)
                                e.src = e.data.dataset[Math.floor(Math.random() * e.data.dataset.length)]
                                t.result.image = e.src
                            }else if(e.type == "text"){
                                var items = []
                                _.forEach(e.data.dataset, (p, idx)=>{
                                    let item = {...res.overlays[index]}
                                    item.t = p
                                    item.ty = "random"
                                    items.push(item)
                                })
                                t.fullResult.push(items)
                                e.t = e.data.dataset[Math.floor(Math.random() * e.data.dataset.length)]
                            }else{
                                var items = []
                                _.forEach(e.data.dataset, (p, idx)=>{
                                    let item = {...res.overlays[index]}
                                    item.t = p
                                    item.ty = "random"
                                    items.push(item)
                                })
                                t.fullResult.push(items)
                            }
                        }else if(e.data.operation.operator == "general"){                                           
                            if(t.general == null){
                                t.general = Math.floor(Math.random() * e.data.dataset.length);
                                if (e.type == "background") {
                                    var items = []
                                    _.forEach(e.data.dataset, (p, idx)=>{
                                        let item = {...res.overlays[index]}
                                        item.src = p
                                        item.ty = "general"
                                        items.push(item)
                                    })
                                    t.fullResult.push(items)
                                    e.src = e.data.dataset[t.general]
                                    t.result.image = e.src
                                }else{
                                    var items = []
                                    _.forEach(e.data.dataset, (p, idx)=>{
                                        let item = {...res.overlays[index]}
                                        item.t = p
                                        item.ty = "general"
                                        items.push(item)
                                    })
                                    t.fullResult.push(items)
                                    e.t = e.data.dataset[t.general];
                                }
                            }else{
                                if (e.type == "background") {
                                    var items = []
                                    _.forEach(e.data.dataset, (p, idx)=>{
                                        let item = {...res.overlays[index]}
                                        item.src = p
                                        item.ty = "general"
                                        items.push(item)
                                    })
                                    t.fullResult.push(items)
                                    e.src = e.data.dataset[t.general]
                                    t.result.image = e.src
                                }else{
                                    var items = []
                                    _.forEach(e.data.dataset, (p, idx)=>{
                                        let item = {...res.overlays[index]}
                                        item.t = p
                                        item.ty = "general"
                                        items.push(item)
                                    })
                                    t.fullResult.push(items)
                                    e.t = e.data.dataset[t.general];
                                }
                                 
                            } 
                        }else{
                            var data = e.data.operation.operands[t.mutilData[e.data.operation.operator].va]
                            var ran = data[Math.floor(Math.random() * data.length)]
                            if (e.type == "background") {
                                var items = []
                                    _.forEach(data, (p, idx)=>{
                                        let item = {...res.overlays[index]}
                                        item.src = p
                                        item.ty = "general"
                                        items.push(item)
                                    })
                                    t.fullResult.push(items)
                                e.src = e.data.dataset[ran]
                                t.result.image = e.src
                            }else{
                                var items = []
                                _.forEach(data, (p, idx)=>{
                                    let item = {...res.overlays[index]}
                                    item.t = p
                                    item.ty = "random"
                                    items.push(item)
                                })
                                t.fullResult.push(items)
                                e.t = e.data.dataset[ran]
                            }
                        }
                    }else{
                        if(e.type == "text" && _.isArray(e.t)){
                            var items = []
                            _.forEach(e.t, (p, idx)=>{
                                let item = {...res.overlays[index]}
                                item.t = p
                                item.ty = "ok"
                                items.push(item)
                            })
                            t.fullResult.push(items)
                        }else{
                            var items = []
                            let item = {...res.overlays[index]}
                            item.ty = "ok"
                            items.push(item)
                            t.fullResult.push(items)
                        }
                    }
                })
                // console.log(t.fullResult)
                for (let index1 = 0; index1 < t.fullResult[0].length; index1++) {
                    let e1 = t.fullResult[0];
                    if(t.fullResult.length > 1){
                        for (let index2 = 0; index2 < t.fullResult[1].length; index2++) {
                            let e2 = t.fullResult[1];
                            if(t.fullResult.length > 2){
                                for (let index3 = 0; index3 < t.fullResult[2].length; index3++) {
                                    let e3 = t.fullResult[2];
                                    if(t.fullResult.length > 3){
                                        for (let index4 = 0; index4 < t.fullResult[3].length; index4++) {
                                            let e4 = t.fullResult[3];
                                            if(t.fullResult.length > 4){
                                                for (let index5 = 0; index5 < t.fullResult[4].length; index5++) {
                                                    let e5 = t.fullResult[4];
                                                    if(t.fullResult.length > 5){
                                                        for (let index6 = 0; index6 < t.fullResult[5].length; index6++) {
                                                            let e6 = t.fullResult[5];
                                                            //end
                                                            if(t.fullResult.length > 6){
                                                                for (let index7 = 0; index7 < t.fullResult[6].length; index7++) {
                                                                    let e7 = t.fullResult[6];
                                                                    //end 6
                                                                    if(t.fullResult.length > 7){
                                                                        for (let index8 = 0; index8 < t.fullResult[7].length; index8++) {
                                                                            let e8 = t.fullResult[7];
                                                                            //end 7
                                                                            if(t.fullResult.length > 8){
                                                                                for (let index9 = 0; index9 < t.fullResult[8].length; index9++) {
                                                                                    let e9 = t.fullResult[8];
                                                                                    //end 8
                                                                                    if(t.fullResult.length > 9){
                                                                                        for (let index10 = 0; index10 < t.fullResult[9].length; index10++) {
                                                                                            let e10 = t.fullResult[9];
                                                                                            //end 9
                                                                                            if(t.fullResult.length > 10){
                                                                                                for (let index11 = 0; index11 < t.fullResult[10].length; index11++) {
                                                                                                    let e11 = t.fullResult[10];
                                                                                                    //end 10
                                                                                                    if(t.fullResult.length > 11){
                                                                                                        for (let index12 = 0; index12 < t.fullResult[11].length; index12++) {
                                                                                                            let e12 = t.fullResult[11];
                                                                                                            //end 11
                                                                                                            if(t.fullResult.length > 12){
                                                                                                                for (let index13 = 0; index13 < t.fullResult[12].length; index13++) {
                                                                                                                    let e13 = t.fullResult[12];
                                                                                                                    //end 12
                                                                                                                    if(t.fullResult.length > 13){
                                                                                                                        for (let index14 = 0; index14 < t.fullResult[13].length; index14++) {
                                                                                                                            let e14 = t.fullResult[13];
                                                                                                                            //end 13
                                                                                                                            if(t.fullResult.length > 14){
                                                                                                                                for (let index15 = 0; index15 < t.fullResult[14].length; index15++) {
                                                                                                                                    let e15 = t.fullResult[14];
                                                                                                                                    //end 14
                                                                                                                                    if(t.fullResult.length > 15){
                                                                                                                                        for (let index16 = 0; index16 < t.fullResult[15].length; index16++) {
                                                                                                                                            let e16 = t.fullResult[15];
                                                                                                                                            //end 15
                                                                                                                                            if(t.fullResult.length > 16){
                                                                                                                                                for (let index17 = 0; index17 < t.fullResult[15].length; index17++) {
                                                                                                                                                    let e17 = t.fullResult[16];
                                                                                                                                                    //end 16
                                                                                                                                                }
                                                                                                                                            }else{
                                                                                                                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10], e11[index11], e12[index12], e13[index13], e14[index14], e15[index15], e16[index16]]})
                                                                                                                                                console.log(item)
                                                                                                                                                if(e1[index1].type === "background"){
                                                                                                                                                    item.image = e1[index1].src
                                                                                                                                                    if(e1[index1].ty == "general"){
                                                                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                                                                    }else{
                                                                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                                                                    }
                                                                                                                                                }

                                                                                                                                                if(e2[index2].type === "background"){
                                                                                                                                                    item.image = e2[index2].src
                                                                                                                                                    // console.log(e2[index2].src)
                                                                                                                                                    if(e2[index2].ty == "general"){
                                                                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                                                                    }else{
                                                                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                // console.log(item)
                                                                                                                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                                                                // console.log(data)
                                                                                                                                                t.resultData.push(data)
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }else{
                                                                                                                                        // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                                                        var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10], e11[index11], e12[index12], e13[index13], e14[index14], e15[index15]]})
                                                                                                                                        console.log(item)
                                                                                                                                        if(e1[index1].type === "background"){
                                                                                                                                            item.image = e1[index1].src
                                                                                                                                            if(e1[index1].ty == "general"){
                                                                                                                                                item.overlays[0].src = e1[index1].src
                                                                                                                                            }else{
                                                                                                                                                item.overlays[0].src = e1[index1].src
                                                                                                                                            }
                                                                                                                                        }

                                                                                                                                        if(e2[index2].type === "background"){
                                                                                                                                            item.image = e2[index2].src
                                                                                                                                            // console.log(e2[index2].src)
                                                                                                                                            if(e2[index2].ty == "general"){
                                                                                                                                                item.overlays[1].src = e2[index2].src
                                                                                                                                            }else{
                                                                                                                                                item.overlays[1].src = e2[index2].src
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        // console.log(item)
                                                                                                                                        let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                                                        // console.log(data)
                                                                                                                                        t.resultData.push(data)
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }else{
                                                                                                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10], e11[index11], e12[index12], e13[index13], e14[index14]]})
                                                                                                                                console.log(item)
                                                                                                                                if(e1[index1].type === "background"){
                                                                                                                                    item.image = e1[index1].src
                                                                                                                                    if(e1[index1].ty == "general"){
                                                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                                                    }else{
                                                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                                                    }
                                                                                                                                }

                                                                                                                                if(e2[index2].type === "background"){
                                                                                                                                    item.image = e2[index2].src
                                                                                                                                    // console.log(e2[index2].src)
                                                                                                                                    if(e2[index2].ty == "general"){
                                                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                                                    }else{
                                                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                // console.log(item)
                                                                                                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                                                // console.log(data)
                                                                                                                                t.resultData.push(data)
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }else{
                                                                                                                        // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                                        var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10], e11[index11], e12[index12], e13[index13]]})
                                                                                                                        if(e1[index1].type === "background"){
                                                                                                                            item.image = e1[index1].src
                                                                                                                            if(e1[index1].ty == "general"){
                                                                                                                                item.overlays[0].src = e1[index1].src
                                                                                                                            }else{
                                                                                                                                item.overlays[0].src = e1[index1].src
                                                                                                                            }
                                                                                                                        }

                                                                                                                        if(e2[index2].type === "background"){
                                                                                                                            item.image = e2[index2].src
                                                                                                                            // console.log(e2[index2].src)
                                                                                                                            if(e2[index2].ty == "general"){
                                                                                                                                item.overlays[1].src = e2[index2].src
                                                                                                                            }else{
                                                                                                                                item.overlays[1].src = e2[index2].src
                                                                                                                            }
                                                                                                                        }
                                                                                                                        // console.log(item)
                                                                                                                        let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                                        // console.log(data)
                                                                                                                        t.resultData.push(data)
                                                                                                                    }
                                                                                                                }
                                                                                                            }else{
                                                                                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10], e11[index11], e12[index12]]})
                                                                                                                if(e1[index1].type === "background"){
                                                                                                                    item.image = e1[index1].src
                                                                                                                    if(e1[index1].ty == "general"){
                                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                                    }else{
                                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                                    }
                                                                                                                }

                                                                                                                if(e2[index2].type === "background"){
                                                                                                                    item.image = e2[index2].src
                                                                                                                    // console.log(e2[index2].src)
                                                                                                                    if(e2[index2].ty == "general"){
                                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                                    }else{
                                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                                    }
                                                                                                                }
                                                                                                                // console.log(item)
                                                                                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                                // console.log(data)
                                                                                                                t.resultData.push(data)
                                                                                                            }
                                                                                                        }
                                                                                                    }else{
                                                                                                        // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                        var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10], e11[index11]]})
                                                                                                        if(e1[index1].type === "background"){
                                                                                                            item.image = e1[index1].src
                                                                                                            if(e1[index1].ty == "general"){
                                                                                                                item.overlays[0].src = e1[index1].src
                                                                                                            }else{
                                                                                                                item.overlays[0].src = e1[index1].src
                                                                                                            }
                                                                                                        }

                                                                                                        if(e2[index2].type === "background"){
                                                                                                            item.image = e2[index2].src
                                                                                                            // console.log(e2[index2].src)
                                                                                                            if(e2[index2].ty == "general"){
                                                                                                                item.overlays[1].src = e2[index2].src
                                                                                                            }else{
                                                                                                                item.overlays[1].src = e2[index2].src
                                                                                                            }
                                                                                                        }
                                                                                                        // console.log(item)
                                                                                                        let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                        // console.log(data)
                                                                                                        t.resultData.push(data)
                                                                                                    }
                                                                                                }
                                                                                            }else{
                                                                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9], e10[index10]]})
                                                                                                if(e1[index1].type === "background"){
                                                                                                    item.image = e1[index1].src
                                                                                                    if(e1[index1].ty == "general"){
                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                    }else{
                                                                                                        item.overlays[0].src = e1[index1].src
                                                                                                    }
                                                                                                }

                                                                                                if(e2[index2].type === "background"){
                                                                                                    item.image = e2[index2].src
                                                                                                    // console.log(e2[index2].src)
                                                                                                    if(e2[index2].ty == "general"){
                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                    }else{
                                                                                                        item.overlays[1].src = e2[index2].src
                                                                                                    }
                                                                                                }
                                                                                                // console.log(item)
                                                                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                                                                // console.log(data)
                                                                                                t.resultData.push(data)
                                                                                            }
                                                                                        }
                                                                                    }else{
                                                                                        // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                        var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8], e9[index9]]})
                                                                                        if(e1[index1].type === "background"){
                                                                                            item.image = e1[index1].src
                                                                                            if(e1[index1].ty == "general"){
                                                                                                item.overlays[0].src = e1[index1].src
                                                                                            }else{
                                                                                                item.overlays[0].src = e1[index1].src
                                                                                            }
                                                                                        }

                                                                                        if(e2[index2].type === "background"){
                                                                                            item.image = e2[index2].src
                                                                                            // console.log(e2[index2].src)
                                                                                            if(e2[index2].ty == "general"){
                                                                                                item.overlays[1].src = e2[index2].src
                                                                                            }else{
                                                                                                item.overlays[1].src = e2[index2].src
                                                                                            }
                                                                                        }
                                                                                        // console.log(item)
                                                                                        let data = await t.preloadCanvasAssetsAsync(item)
                                                                                        // console.log(data)
                                                                                        t.resultData.push(data)
                                                                                    }
                                                                                }
                                                                            }else{
                                                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7], e8[index8]]})
                                                                                if(e1[index1].type === "background"){
                                                                                    item.image = e1[index1].src
                                                                                    if(e1[index1].ty == "general"){
                                                                                        item.overlays[0].src = e1[index1].src
                                                                                    }else{
                                                                                        item.overlays[0].src = e1[index1].src
                                                                                    }
                                                                                }

                                                                                if(e2[index2].type === "background"){
                                                                                    item.image = e2[index2].src
                                                                                    // console.log(e2[index2].src)
                                                                                    if(e2[index2].ty == "general"){
                                                                                        item.overlays[1].src = e2[index2].src
                                                                                    }else{
                                                                                        item.overlays[1].src = e2[index2].src
                                                                                    }
                                                                                }
                                                                                // console.log(item)
                                                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                                                // console.log(data)
                                                                                t.resultData.push(data)
                                                                            }
                                                                        }
                                                                    }else{
                                                                        // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                        var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6], e7[index7]]})
                                                                        if(e1[index1].type === "background"){
                                                                            item.image = e1[index1].src
                                                                            if(e1[index1].ty == "general"){
                                                                                item.overlays[0].src = e1[index1].src
                                                                            }else{
                                                                                item.overlays[0].src = e1[index1].src
                                                                            }
                                                                        }

                                                                        if(e2[index2].type === "background"){
                                                                            item.image = e2[index2].src
                                                                            // console.log(e2[index2].src)
                                                                            if(e2[index2].ty == "general"){
                                                                                item.overlays[1].src = e2[index2].src
                                                                            }else{
                                                                                item.overlays[1].src = e2[index2].src
                                                                            }
                                                                        }
                                                                        // console.log(item)
                                                                        let data = await t.preloadCanvasAssetsAsync(item)
                                                                        // console.log(data)
                                                                        t.resultData.push(data)
                                                                    }
                                                                }
                                                            }else{
                                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5], e6[index6]]})
                                                                if(e1[index1].type === "background"){
                                                                    item.image = e1[index1].src
                                                                    if(e1[index1].ty == "general"){
                                                                        item.overlays[0].src = e1[index1].src
                                                                    }else{
                                                                        item.overlays[0].src = e1[index1].src
                                                                    }
                                                                }

                                                                if(e2[index2].type === "background"){
                                                                    item.image = e2[index2].src
                                                                    // console.log(e2[index2].src)
                                                                    if(e2[index2].ty == "general"){
                                                                        item.overlays[1].src = e2[index2].src
                                                                    }else{
                                                                        item.overlays[1].src = e2[index2].src
                                                                    }
                                                                }
                                                                // console.log(item)
                                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                                // console.log(data)
                                                                t.resultData.push(data)
                                                            }
                                                        }
                                                    }else{
                                                        // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                        var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4], e5[index5]]})
                                                        if(e1[index1].type === "background"){
                                                            item.image = e1[index1].src
                                                            if(e1[index1].ty == "general"){
                                                                item.overlays[0].src = e1[index1].src
                                                            }else{
                                                                item.overlays[0].src = e1[index1].src
                                                            }
                                                        }

                                                        if(e2[index2].type === "background"){
                                                            item.image = e2[index2].src
                                                            // console.log(e2[index2].src)
                                                            if(e2[index2].ty == "general"){
                                                                item.overlays[1].src = e2[index2].src
                                                            }else{
                                                                item.overlays[1].src = e2[index2].src
                                                            }
                                                        }
                                                        // console.log(item)
                                                        let data = await t.preloadCanvasAssetsAsync(item)
                                                        // console.log(data)
                                                        t.resultData.push(data)
                                                    }
                                                }
                                            }else{
                                                // console.log(e1[index1], e2[index2], e3[index3], e4[index4])
                                                var item = Object.assign({...t.result}, {overlays: [e1[index1], e2[index2], e3[index3], e4[index4]]})
                                                if(e1[index1].type === "background"){
                                                    item.image = e1[index1].src
                                                    if(e1[index1].ty == "general"){
                                                        item.overlays[0].src = e1[index1].src
                                                    }else{
                                                        item.overlays[0].src = e1[index1].src
                                                    }
                                                }

                                                if(e2[index2].type === "background"){
                                                    item.image = e2[index2].src
                                                    // console.log(e2[index2].src)
                                                    if(e2[index2].ty == "general"){
                                                        item.overlays[1].src = e2[index2].src
                                                    }else{
                                                        item.overlays[1].src = e2[index2].src
                                                    }
                                                }
                                                // console.log(item)
                                                let data = await t.preloadCanvasAssetsAsync(item)
                                                // console.log(data)
                                                t.resultData.push(data)
                                            }
                                        }
                                    }else{
                                        console.log(e1, e2, e3)
                                    }
                                }
                            }else{
                                console.log(e1, e2)
                            }
                            
                        }
                    }else{
                        console.log(e1)
                    }
                }
                t.$store.state.result = "choose_mutil_inputs : "+rd;
                t.current_step = "canvas_generating";
                
                // t.preloadCanvasAssetsAsync(function() {
                //     t.canvas_ready = true;
                //     t.current_step = "initial";        
                // });
            }catch(err){
                console.log(err)
                window.gtag("event", "beforeMutilApp err", {
                    event_category: "beforeMutilApp err",
                    event_label: err + "--" + t.$route.params.game_id + "--" + JSON.stringify(t.result),
                    value: 1 
                });
            }
            
        },
        getImage64: function(e) {
            return new Promise(function(resolve, reject){
                var a = new XMLHttpRequest;
                a.onload = function() {
                    
                    var e = new FileReader;
                    e.onloadend = function() {
                        resolve(e.result)
                    };
                    e.readAsDataURL(a.response)
                };
                a.onerror = function () {
                    reject(e)
                };
                a.open("GET", e);
                a.responseType = "blob";
                a.send()
            })
        },
        getImage64Post: function(e, t, a, n, o) {
            var i = new XMLHttpRequest;
            i.onload = function() {
                var e = new FileReader;
                e.onloadend = function() {
                    o(e.result, n)
                };
                e.readAsDataURL(i.response)
            };
            i.open("POST", e, true);
            i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            i.responseType = "blob";
            i.send("id=" + this.getUserInfo.id + "&filter=" + t + "&data=" + encodeURI(a))
        },
        loadImage: function (src) {
            return new Promise(function(resolve, reject){
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.addEventListener("load", function(){
                    resolve(img)
                });
                img.addEventListener("error", function(err){
                    reject(err)
                });
                img.src = src;
            });
        },
        base64Img: function(url){
            return axios
            .get(url, {
              responseType: 'arraybuffer'
            })
            .then(function(response){
                resolve(Buffer.from(response.data, 'binary').toString('base64'))  
            })
            .catch(function(err){
                reject(err)
            })
        },
        preloadCanvasAssetsAsync: async function(result){
            try{
                var t = this;
                return new Promise(async (resolve, reject)=>{
                    if(_.isArray(result)){
                        result = result[0]
                    }
                    if (_.startsWith(result.image, 'static')) {
                        var url = result.image
                    }else{
                        var url = t.getInapp + result.image
                    }
                    let image = await this.loadImage(url);
                    image.setAttribute('crossOrigin', 'anonymous');
                    // console.log(image)
                    t.preloadCanvasFonts(result.overlays, async function() {
                        let img = await t.generateCanvasAsync(result, image);
                        resolve(img)
                    })
                })
            }catch(err){
                console.error(err)
            }
        },
        preloadCanvasFonts: function(e, t) {
            for (var a = [], n = 0; n < e.length; n++){
                if (e[n].type === "text" && !["arial", "helvetica", "georgia", "tahoma"].includes(e[n].f)) {
                    a.push(e[n].f);
                }
            }
            this.loadFonts(a, t)
        },
        loadFonts: function(e, t) {
            for (var a = 0; a < e.length; a++) {
                var n = "fkf_" + e[a];
                if (document.getElementById(n) === null) {
                    var o = this.font_path + e[a] + ".ttf",
                        i = document.createTextNode("\n@font-face {\nfont-family: '" + e[a] + "';\nsrc: url('" + o + "');\n}\n"),
                        s = document.createElement("style");
                    s.type = "text/css";
                    s.id = n;
                    s.appendChild(i);
                    document.head.appendChild(s)
                }
            }
            e.length > 0 ? WebFont.load({
                custom: {
                    families: e
                },
                loading: function() {},
                active: function() {
                    t()
                },
                inactive: function() {
                    t()
                },
                fontloading: function(e, t) {},
                fontactive: function(e, t) {},
                fontinactive: function(e, t) {}
            }) : t()
        },
        getRandomNum: function(min, max) {
            min = parseInt(min);
            max = parseInt(max);
            var count = max - min;
            var irandom = Math.floor(Math.random() * count);
            if (irandom >= count) irandom = count - 1;

            return irandom + min;
        },
        FrankyReplaceStrings: function(e) {
            try{
                var t = this;
                var data = e;
                // console.log(this.getUserInfo)
                data = data.replace(/uc_name/gi, this.getUserInfo.name.toUpperCase());
                data = data.replace(/lc_name/gi, this.getUserInfo.name.toLowerCase());
                data = data.replace(/nm_name/gi, this.getUserInfo.name);
                data = data.replace(/nm_nama/gi, this.getUserInfo.name);
                data = data.replace(/short_name/gi, function(){
                    if (typeof t.getUserInfo.name === "string") {
                        return t.getUserInfo.name.split(" ")[0]
                    }
                    return t.getUserInfo.name
                });
                data = data.replace(/nm_input/gi, this.input);
                data = data.replace(/day_now/gi, (new Date()).getDate());
                data = data.replace(/fullYear_now/gi, (new Date()).getFullYear());
                data = data.replace(/shortYear_now/gi, (new Date()).getFullYear().toString().substring(2));
                data = data.replace(/month_now/gi, ((new Date()).getMonth() + 1));
                data = data.replace(/week_now/gi, (x) => {
                    const date = new Date();
                    const options = { weekday: 'long'};
                    const day = new Intl.DateTimeFormat(this.current_language, options).format(date)
                    return day
                });
                data = data.replace(/\@\{rand\((\d+),(\d+)\)\}/gi, function () {
                    var rtn = t.getRandomNum(arguments[1], arguments[2]);
                    return rtn;
                });

                data = data.replace(/\@mutil_text\((\d+)\)/gi, function () {
                    var rtn = t.imageMultipleSelected[arguments[1]].title
                    return rtn;
                });

                data = data.replace(/\@image_text\((\w+)\)/gi, function(){
                    var rtn = t.mutilData[arguments[1]].data.title
                    return rtn;
                });

                data = data.replace(/\@mutil_input\((\d+)\)/gi, function () {
                    var rtn = t.Minput[arguments[1]]
                    return rtn;
                });

                data = data.replace(/\@mutil_text/gi, function () {
                    var rtn = t.selectText
                    return rtn;
                });

                data = data.replace(/\@scatch_text/gi, function () {
                    var rtn = t.scratch.text
                    return rtn;
                });
                return data;
            }catch(err){
                console.log(err)
                window.gtag("event", "FrankyReplaceStrings err", {
                    event_category: "FrankyReplaceStrings err",
                    event_label: err + "--" + t.$route.params.game_id + "--" + t.current_language,
                    value: 1
                });
            }
        },
        beforeLoadImage: function(o, a, i, n, t){
            try{
                var self = this;
                t.translate(o.x, o.y);
                t.rotate(a);
                t.drawImage(n, 0, 0, o.w, o.h);
                t.rotate(-a);
                t.translate(-o.x, -o.y);
                self.texts_loaded[i] = true
            }catch(err){
                window.gtag("event", "beforeLoadImage err", {
                    event_category: "beforeLoadImage err",
                    event_label: err,
                    value: 1
                });
            }
        },
        beforeErrorImage: function(o, a, i, t){
            try{
                var self = this;
                t.translate(o.x, o.y);
                t.rotate(a);
                t.drawImage(o.object, 0, 0, o.w, o.h);
                t.rotate(-a);
                t.translate(-o.x, -o.y);
                self.texts_loaded[i] = true
            }catch(err){
                window.gtag("event", "beforeErrorImage err", {
                    event_category: "beforeErrorImage err",
                    event_label: err + "-" + self.game_id,
                    value: 1
                });
            }
        },
        FrankyDrawPicturesAsync: async function(o, i, t) {
            try{
                var self = this;
                var a = o.a * Math.PI / 180;
                await this.loadImage(o.url)
                .then(function(img){
                    self.beforeLoadImage(o, a, i, img, t)
                })
                .catch(function(err){
                    window.gtag("event", "FrankyDrawPicturesAsync err load first", {
                        event_category: "FrankyDrawPicturesAsync err load first",
                        event_label: err + " src: " + o.url,
                        value: 1
                    });
                    self.beforeErrorImage(o, a, i, t)
                })
            }catch(err){
                window.gtag("event", "FrankyDrawPicturesAsync err", {
                    event_category: "FrankyDrawPicturesAsync err",
                    event_label: err + JSON.stringify(self.result),
                    value: 1
                });
            }
        },
        FrankyDrawAvatarMask: function(e, index, t) {
            var self = this
            try{
                return new Promise(async function(resolve, reject){
                    var o = e
                    var canvas = document.createElement("canvas")
                    canvas.width = self.result.width
                    canvas.height = self.result.height
                    var ctx = canvas.getContext("2d")
                    var a = 0
                    // console.log(self.getUserInfo.friends)
                    if (self.getUserInfo.pictureObj == null) {
                        try{
                            let img = await self.loadImage(self.getUserInfo.picture)
                            self.getUserInfo.pictureObj = img
                        }catch(err){
                            console.log(err)
                        }   
                        
                    }
                    self.loadImage(self.getInapp + self.game_id + "/" + o.m)
                    .then(function(mask){
                        let scaleH = o.fl ? -1 : 1,
                            scaleV = 1,
                            posX = o.fl ? o.w * -1 : 0,
                            posY = 0;
                        ctx.save();
                        a = o.a * Math.PI / 180;
                        ctx.translate(o.x, o.y);
                        ctx.rotate(a);
                        ctx.scale(scaleH, scaleV);
                        ctx.drawImage(self.getUserInfo.pictureObj, posX, posY, o.w, o.h);
                        ctx.rotate(-a);
                        ctx.translate(-o.x, -o.y);
                        ctx.restore();
                        ctx.globalCompositeOperation = "source-in";
                        ctx.globalCompositeOperation = "destination-atop";
                        ctx.drawImage(mask, 0, 0);
                        t.drawImage(canvas, 0, 0);
                        
                        resolve()
                    })
                    .catch((err)=>{
                        console.log(err)
                        reject(err)
                    })
                })
            }catch(err){
                analytic("FrankyDrawAvatar err", "FrankyDrawAvatar err", JSON.stringify(err))
            }
        },
        FrankyDrawPictures: function(e, t) {
            try{
                var self = this;
                for (var a = 0, n = 0; n < e.length; n++) {
                    var o = e[n];
                    if (o.type === "profile") {
                        o.myIndex = n;
                        if (self.getUserInfo.pictureObj == null) {
                            self.loadImage(self.getUserInfo.picture)
                            .then(function(img){
                                self.getUserInfo.pictureObj = img
                                a = o.a * Math.PI / 180;
                                t.translate(o.x, o.y);
                                t.rotate(a);
                                t.drawImage(img, 0, 0, o.w, o.h);
                                t.rotate(-a);
                                t.translate(-o.x, -o.y);
                            })
                            .catch(function(err){
                                console.log(err)
                            })
                        }else{
                            a = o.a * Math.PI / 180;
                            t.translate(o.x, o.y);
                            t.rotate(a);
                            t.drawImage(self.getUserInfo.pictureObj, 0, 0, o.w, o.h);
                            t.rotate(-a);
                            t.translate(-o.x, -o.y);
                        }
                    }else if (o.type === "picture") {
                        a = o.a * Math.PI / 180;
                        t.translate(o.x, o.y);
                        t.rotate(a);
                        t.drawImage(a.url, 0, 0, o.w, o.h);
                        t.rotate(-a);
                        t.translate(-o.x, -o.y);
                    }
                }
            }catch(err){
                console.log(err)
            }
        },
        FrankyText: function(e, t, a) {
            var o = this
            try{
                return new Promise((resolve, reject)=>{
                    var i = document.createElement("canvas");
                    i.width = a.w;
                    i.height = a.h;
                    var s = i.getContext("2d");
                    if (a.c) {
                        s.fillStyle = a.c
                    }
                    if (a.grd) {
                        if (a.grdI.length) {
                            var r = s.createLinearGradient(0, 0, i.width, 0);
                            for (var k = 0; k < a.grdI.length; k++) {
                                r.addColorStop(a.grdI[k][0], a.grdI[k][1]);
                            }
                            s.fillStyle = r;
                        }
                    }
                    var c = a.fs + "px " + a.f;
                    if (a.sb) c = "bold " + c;
                    if (a.si) c = "italic " + c;
                    
                    this.DrawTextToCanvas(i, t, {
                        font: c,
                        textAlign: a.ta,
                        verticalAlign: a.va,
                        sizeToFill: true,
                        FontSizeToFill: a.hl,
                        maxFontSizeToFill: a.fs,
                        justifyLines: false,
                        renderHDPI: false,
                        paddingY: 1,
                        strokeText: a.st,
                        strokeStyle: a.stcl,
                        lineWidth: a.lw,
                        direction: ["ar", "ur", "ps","fa","he"].includes(o.current_language) ? "rtl" : "ltr" //change1
                    });
                    var l = i.toDataURL("image/png"),
                        u = new Image;
                    u.onload = function() {
                        var t = a.a * Math.PI / 180;
                        e.translate(a.x, a.y);
                        e.rotate(t);
                        e.drawImage(u, 0, 0, a.w, a.h);
                        e.rotate(-t);
                        e.translate(-a.x, -a.y);
                        resolve(true)
                    }, u.src = l
                })
                
            }catch(err){
                console.log(err)
            }
        },
        DrawTextToCanvas: function(t, a, n){
            try{
                var self = this
                var r = {}, d = 1, s = {
                    font: "18px Arial, sans-serif",
                    sizeToFill: false,
                    FontSizeToFill: 0,
                    maxFontSizeToFill: false,
                    lineHeight: 1,
                    allowNewLine: true,
                    lineBreak: "auto",
                    textAlign: "left",
                    verticalAlign: "top",
                    justifyLines: false,
                    paddingX: 0,
                    paddingY: 0,
                    fitParent: false,
                    strokeText: false,
                    lineWidth: 3,
                    strokeStyle: "#000000",
                    renderHDPI: true,
                    textDecoration: "none",
                    direction: "ltr" //change1
                };
                for (var i in s){
                    r[i] = n.hasOwnProperty(i) ? n[i] : s[i];
                }
                var c = t.getContext("2d");
                c.font = r.font;
                c.textBaseline = "bottom";
                c.direction = r.direction;
                if (r.strokeText) {
                    c.strokeStyle = r.strokeStyle
                    c.lineWidth = r.lineWidth
                }
                var l = window.devicePixelRatio;
                if (r.renderHDPI && l > 1) {
                    var u = {};
                    for (i in c) u[i] = c[i];
                    var m = t.width,
                        h = t.height;
                        d = l;
                    t.width = m * d;
                    t.height = h * d;
                    t.style.width = m * d * .5 + "px";
                    t.style.height = h * d * .5 + "px";   

                    for(i in u){
                        c[i] = u[i]
                    }
                    c.scale(d, d)
                }
                var g, x = (r.fitParent ? t.parentNode.clientWidth : t.width) / d,
                    p = (r.fitParent ? t.parentNode.clientHeight : t.height) / d,
                    v = x - 2 * r.paddingX,
                    f = p - 2 * r.paddingY,
                    w = r.font.match(/\d+(px|em|%)/g) ? +r.font.match(/\d+(px|em|%)/g)[0].match(/\d+/g) : 18,
                    _ = 0,
                    k = [],
                    b = [],
                    y = {
                        x: 0,
                        y: 0
                    },
                    z = 0,
                    I = "​";
                function T(e) {
                    do {
                        e = e.replace(/\n\n/g, "\n" + I + "\n")
                    } while (e.indexOf("\n\n") > -1);
                    return e
                }

                function j(e) {
                    if (!g) {
                        g = r.sizeToFill ? c.font.split(/\b\d+px\b/i) : r.font.split(/\b\d+px\b/i);
                    }
                    c.font = g[0] + e + "px" + g[1];
                }

                function S() {
                    if (isNaN(r.lineHeight)) {
                        if (r.lineHeight.toString().indexOf("px") !== -1) {
                            z = parseInt(r.lineHeight)
                        }else{
                            if (r.lineHeight.toString().indexOf("%") !== -1) {
                                z = parseInt(r.lineHeight) / 100 * w
                            }
                        }
                    }else{
                        z = w * r.lineHeight
                    }
                }

                function F() {
                    if (r.sizeToFill) {
                        var e = a.trim().split(/\s+/).length,
                            t = 0,
                            n = !1 !== r.maxFontSizeToFill;
                        do {
                            if (n) {
                                if (!(++t <= r.maxFontSizeToFill)) break;
                                C(t)
                            } else C(++t);
                            _ += 1, _ -= 1, f += 1, f -= 1
                        } while (_ < f && k.join(" ").split(/\s+/).length === e);
                        C(--t)
                    } else{
                        A();
                    }
                    if (r.justifyLines && r.lineBreak === "auto") {
                        E();
                        
                    }
                    Alignvertical();
                    Horizontallandscape();
                    Drawletters()
                }

                function C(e) {
                    j(e);
                    z = e;
                    A()
                }

                function A() {
                    if (r.allowNewLine) {
                        for (var e = a.trim().split("\n"), t = 0, n = 0; t < e.length - 1; t++){
                            n += e[t].trim().split(/\s+/).length;
                            b.push(n);
                        }
                    }
                    var o = a.trim().split(/\s+/);
                    B(o);
                    P(o);
                    _ = k.length * z;
                }

                function B(e) {
                    var t, a, n, o;
                    e.forEach(function(i, s) {
                        t = "";
                        a = c.measureText(i).width;
                        if (a > v) {

                            for (var r = 0; c.measureText(t + i[r]).width <= v && r < i.length; r++){
                                t += i[r];
                            }
                            n = i.slice(0, r);
                            o = i.slice(r);
                            e.splice(s, 1, n, o)
                        }
                    })
                }

                function P(e) {
                    k = [];
                    for (var t = 0, a = 0; t < e.length; a++)
                        if (k[a] = "", "auto" === r.lineBreak) {
                            if (c.measureText(k[a] + e[t]).width > v) break;
                            while (c.measureText(k[a] + e[t]).width <= v && t < e.length)
                                if (k[a] += e[t] + " ", t++, r.allowNewLine)
                                    for (var n = 0; n < b.length; n++)
                                        if (b[n] === t) {
                                            a++, k[a] = "";
                                            break
                                        } k[a] = k[a].trim()
                        } else k[a] = e[t], t++
                }

                function E() {
                    for (var e, t, a, n, o, i, s, r, d = 0; d < k.length; d++){
                        a = c.measureText(k[d]).width;
                        if(!e || a > e){
                            e = a;
                            t = d;
                        }
                    }
                    var l = " ";
                    for (d = 0; d < k.length; d++)
                        if (d !== t && (n = k[d].trim().split(/\s+/).length, !(n <= 1))) {
                            k[d] = k[d].trim().split(/\s+/).join(l), o = c.measureText(l).width, i = (e - c.measureText(k[d]).width) / o, s = i / (n - 1), r = "";
                            for (var u = 0; u < s; u++) r += l;
                            k[d] = k[d].trim().split(l).join(r)
                        }
                }

                function $(e, t, a) {
                    var n = c.measureText(e).width;
                    switch (c.textAlign) {
                        case "center":
                            t -= n / 2;
                            break;
                        case "right":
                            t -= n;
                            break
                    }
                    c.beginPath(), c.moveTo(t, a), c.lineTo(t + n, a), c.stroke()
                }

                function Drawletters() {
                    for (var e = I + " ", t = 0; t < k.length; t++) {
                        y.y = parseInt(y.y) + z + r.FontSizeToFill;
                        if (e !== k[t]) {
                            if (r.strokeText) {
                                c.strokeText(k[t], y.x, y.y)
                            }
                            c.fillText(k[t], y.x, y.y);
                            if (r.textDecoration.toLocaleLowerCase() === "underline") {
                                $(k[t], y.x, y.y)
                            }
                        }
                    }
                }

                function Horizontallandscape() {
                    c.textAlign = r.textAlign;
                    if (r.textAlign === "center") {
                        y.x = x / 2
                    }else if (r.textAlign === "right") {
                        y.x = x - r.paddingX
                    }else{
                        y.x = r.paddingX
                    }
                }

                function Alignvertical(){
                    if (r.verticalAlign === "middle") {
                        y.y = (p - _) / 2
                    }else if (r.verticalAlign === "bottom") {
                        y.y = p - _ - r.paddingY
                    }else{
                        y.y = r.paddingY
                    }
                }

                function q() {
                    if ("string" !== typeof a) throw new TypeError("The second parameter must be a String.");
                    if (isNaN(w)) throw new TypeError('Cannot parse "font".');
                    if (isNaN(z)) throw new TypeError('Cannot parse "lineHeight".');
                    if ("left" !== r.textAlign.toLocaleLowerCase() && "center" !== r.textAlign.toLocaleLowerCase() && "right" !== r.textAlign.toLocaleLowerCase()) throw new TypeError('Property "textAlign" must be set to either "left", "center", or "right".');
                    if ("top" !== r.verticalAlign.toLocaleLowerCase() && "middle" !== r.verticalAlign.toLocaleLowerCase() && "bottom" !== r.verticalAlign.toLocaleLowerCase()) throw new TypeError('Property "verticalAlign" must be set to either "top", "middle", or "bottom".');
                    if ("boolean" !== typeof r.justifyLines) throw new TypeError('Property "justifyLines" must be a Boolean.');
                    if (isNaN(r.paddingX)) throw new TypeError('Property "paddingX" must be a Number.');
                    if (isNaN(r.paddingY)) throw new TypeError('Property "paddingY" must be a Number.');
                    if ("boolean" !== typeof r.fitParent) throw new TypeError('Property "fitParent" must be a Boolean.');
                    if ("auto" !== r.lineBreak.toLocaleLowerCase() && "word" !== r.lineBreak.toLocaleLowerCase()) throw new TypeError('Property "lineBreak" must be set to either "auto" or "word".');
                    if ("boolean" !== typeof r.sizeToFill) throw new TypeError('Property "sizeToFill" must be a Boolean.');
                    if ("boolean" !== typeof r.strokeText) throw new TypeError('Property "strokeText" must be a Boolean.');
                    if ("boolean" !== typeof r.renderHDPI) throw new TypeError('Property "renderHDPI" must be a Boolean.');
                    if ("none" !== r.textDecoration.toLocaleLowerCase() && "underline" !== r.textDecoration.toLocaleLowerCase()) throw new TypeError('Property "textDecoration" must be set to either "none" or "underline".')
                }

                a = T(a);
                j(w);
                S();
                q();
                F();
                return k;
            }catch(err){
                window.gtag("event", "DrawTextToCanvas err", {
                    event_category: "DrawTextToCanvas err",
                    event_label: err + "--" + self.$route.params.game_id + "--" + self.current_language,
                    value: 1
                });
            }
        },

        FrankyDrawTexts: function(e, t) {
            var self = this;
            try{
                return new Promise(async (resolve, reject)=>{
                    var n = e;
                    n.x = parseInt(n.x);
                    n.y = parseInt(n.y);
                    n.w = parseInt(n.w);
                    n.h = parseInt(n.h);
                    n.fs = parseInt(n.fs);
                    if (_.isArray(n.t)) {
                        var p = n.t;
                        o = p[Math.floor(Math.random() * p.length)];
                    }else{
                        var o = n.t;
                    }
                    if (n.tt) {
                        o = n.tt[self.$i18n.locale];
                        o = self.FrankyReplaceStrings(o);
                        if (self.$i18n.locale !== "ja" || self.$i18n.locale !== "th" || self.$i18n.locale !== "zh") {
                            o = o.split("").join(" ")
                        }
                    }else{
                        o = self.FrankyReplaceStrings(o);
                        if (n.tp) o = n.tp[Math.floor(Math.random() * n.tp.length)];
                        if (n.uc) o = o.toUpperCase();
                        var hl = n.hl ? parseInt(n.hl) : 0;
                        var st = n.st ? n.st : false
                        var stcl = n.stcl ? n.stcl : "#3b5999"
                        var lw = n.lw ? n.lw : 3
                        var grd = n.grd ? n.grd : false
                        var grdI = n.grdI ? n.grdI : []
                        await self.FrankyText(t, o, {
                            w: n.w,
                            h: n.h,
                            x: n.x,
                            y: n.y,
                            ta: n.ta,
                            va: n.va,
                            j: n.j,
                            f: n.f,
                            fs: n.fs,
                            c: n.c,
                            si: n.si,
                            sb: n.sb,
                            a: n.a,
                            hl: hl,
                            st: st,
                            stcl: stcl,
                            lw: lw,
                            grd: grd,
                            grdI: grdI
                        })
                    }
                    resolve(t)
                })
            }catch(err){
                console.log(err)
            }
            
        },
        DrawImageFilter: function(e, img, filter){
            return new Promise((resolve, reject)=>{
                const canvas = document.createElement("canvas")
                canvas.width = e.w
                canvas.height = e.h
                const ctx = canvas.getContext("2d")
                ctx.drawImage(img, 0, 0, e.w, e.h)
                const imageData = ctx.getImageData(0, 0, e.w, e.h);
                var filtered;
                try{
                    switch(filter){
                        case "GrayScale":
                            filtered = ImageFilters.GrayScale(imageData);
                            break;
                        case "Emboss":
                            filtered = ImageFilters.Emboss(imageData);
                            break;
                        case "Edge":
                            filtered = ImageFilters.Edge(imageData);
                            break;
                        case "Enrich":
                            filtered = ImageFilters.Enrich(imageData);
                            break;
                        case "GaussianBlur":
                            filtered = ImageFilters.GaussianBlur(imageData, 2);
                            break;
                        case "StackBlur":
                            filtered = ImageFilters.StackBlur(imageData, 6);
                            break;
                        case "BrightnessContrastGimp":
                            filtered = ImageFilters.BrightnessContrastGimp(imageData, 0, 0);
                            break;
                        case "BrightnessContrastPhotoshop":
                            filtered = ImageFilters.BrightnessContrastPhotoshop(imageData, 0, 0);
                            break;
                        case "Dither":
                            filtered = ImageFilters.Dither(imageData, 8);
                            break;
                        case "Mosaic":
                            filtered = ImageFilters.Mosaic(imageData, 2);
                            break;
                        case "Oil":
                            filtered = ImageFilters.Oil(imageData, 2, 32);
                            break;
                        case "Sepia":
                            filtered = ImageFilters.Sepia(imageData);
                            break;
                        case "Sharpen":
                            filtered = ImageFilters.Sharpen(imageData, 3);
                            break;
                        default:
                            filtered = ImageFilters.Original(imageData);
                    }
                    ctx.putImageData(filtered, 0, 0);
                    resolve(canvas)
                    // console.log(canvas.toDataURL("image/jpeg"))
                }catch(err){
                    console.log(err)
                    reject(err)
                }
            })
        },
        FrankyDrawAvatar: function(e, index, t) {
            var self = this

            return new Promise(async function(resolve, reject){
                try{
                    var o = e
                    var a = 0
                    if (self.getUserInfo.pictureObj == null) {
                        try{
                            let img = await self.loadImage(self.getUserInfo.picture)
                            self.getUserInfo.pictureObj = img
                        }catch(err){
                            reject(err)
                        }
                    }
                    if(o.effect == "none"){
                        var image = self.getUserInfo.pictureObj
                        
                    }else{
                        try{
                            var image = await self.DrawImageFilter(o, self.getUserInfo.pictureObj, o.effect)
                        }catch(error){
                            var image = self.getUserInfo.pictureObj
                        }
                        
                    }
                    let scaleH = o.fl ? -1 : 1,
                        scaleV = 1,
                        posX = o.fl ? o.w * -1 : 0,
                        posY = 0;
                    t.save();
                    a = o.a * Math.PI / 180;
                    t.translate(o.x, o.y);
                    t.rotate(a);
                    t.scale(scaleH, scaleV);
                    t.drawImage(image, posX, posY, o.w, o.h);
                    t.rotate(-a);
                    t.translate(-o.x, -o.y);
                    t.restore();
                    self.texts_loaded[index] = true
                    resolve()
                }catch(err){
                    window.gtag("event", "FrankyDrawAvatar err", {
                        event_category: "FrankyDrawAvatar err",
                        event_label: err,
                        value: 1
                    });
                    reject(err)
                }
            })
        },
        FrankyDrawAsync: async function(o, i, t) {
            try{
                var self = this;
                var a = o.a * Math.PI / 180;
                await this.loadImage(o.url)
                .then(function(img){
                    self.beforeLoadImage(o, a, i, img, t)
                })
                .catch(function(err){
                    console.log(err)
                    window.gtag("event", "FrankyDrawPicturesAsync err load first", {
                        event_category: "FrankyDrawPicturesAsync err load first",
                        event_label: err + " src: " + o.url + "-" + self.game_id,
                        value: 1
                    });
                    self.beforeErrorImage(o, a, i, t)
                })
            }catch(err){
                console.log(err)
                window.gtag("event", "FrankyDrawPicturesAsync err", {
                    event_category: "FrankyDrawPicturesAsync err",
                    event_label: err + JSON.stringify(self.result),
                    value: 1
                });
            }
        },
        generateCanvasAsync: async function(result, e) {
            var a = this
            try{
                return new Promise(async function(resolve, reject){
                    let canvas_virtual = document.createElement("canvas");
                    canvas_virtual.width = result.width;
                    canvas_virtual.height = result.height;
                    let canvas_context = canvas_virtual.getContext("2d");
                    var tc = 0
                    for ( const [index, res] of Object.entries(result.overlays)){
                        if (res.type == "picture") {
                            if (res.hasOwnProperty('index')) {
                                res.url = a.getInapp + a.imageMultipleSelected[res.index].src
                                res.object = a.imageMultipleSelected[res.index].object
                                tc++
                            }else{
                                res.url = a.getInapp + a.imageMultipleSelected[tc].src
                                res.object = a.imageMultipleSelected[tc].object
                                tc++
                            }
                            await a.FrankyDrawPicturesAsync(res, index, canvas_context)
                        }else if(res.type == 'photo'){
                            await a.FrankyDrawPicturesAsync(res, index, canvas_context)
                        }else if(res.type == 'draw'){
                            res.url = a.base64Draw
                            await a.FrankyDrawAsync(res, index, canvas_context)
                        }else if (res.type == 'background') {
                            await canvas_context.drawImage(e, 0, 0);
                            a.texts_loaded[index] = true
                        }else if (res.type == "profile") {
                            if(res.effect == "mask"){
                                await a.FrankyDrawAvatarMask(res, index, canvas_context)
                                a.texts_loaded[index] = true
                            }else{
                                await a.FrankyDrawAvatar(res, index, canvas_context)
                            }
                            
                        }else if (res.type == "text") {
                            let text = await a.FrankyDrawTexts(res, canvas_context);
                            canvas_context = text
                            // console.log(text)
                        }
                    }

                    a.canvas_data = canvas_context.getImageData(0, 0, canvas_virtual.width, canvas_virtual.height);
                    resolve(canvas_virtual.toDataURL("image/jpeg"))
                })
                
            }catch(err){
                console.log(err)
            }
        },
        generateCanvas: function(e, t) {
            try{
                this.canvas_virtual = document.createElement("canvas");
                this.canvas_virtual.width = this.result.width;
                this.canvas_virtual.height = this.result.height;
                this.canvas_context = this.canvas_virtual.getContext("2d");
                this.FrankyDrawPictures(this.result.overlays, this.canvas_context);
                this.canvas_context.drawImage(e, 0, 0);
                this.FrankyDrawTexts(this.result.overlays, this.canvas_context);
                var a = this,
                n = setInterval(function() {
                    for (var e = true, o = 0; o < a.texts_loaded.length; o++) {
                        if (!a.texts_loaded[o]) e = false;
                    }
                    if (e) {
                        clearInterval(n);
                        a.canvas_data = a.canvas_context.getImageData(0, 0, a.canvas_virtual.width, a.canvas_virtual.height);
                        t();
                    }
                }, 500)
            }catch(err){
                window.gtag("event", "generateCanvas err", {
                    event_category: "generateCanvas err",
                    event_label: err,
                    value: 1
                });
            }
        },
        showCanvasImage: function() {
            try{
                var e = this.canvas_virtual.toDataURL("image/jpeg");
                this.canvas_image = e
            }catch(err){
                window.gtag("event", "showCanvasImage err", {
                    event_category: "showCanvasImage err",
                    event_label: err,
                    value: 1
                });
            }
        }
    }
}
</script>